import { TextField } from "../../../../utils/form";
import { isValidArgentineMobile } from "../../../../utils/form/validations/phone";

const PhoneInput = ({ form: { control }, required }) => (
  <TextField
    control={control}
    fullWidth
    name="phone"
    label="Número de teléfono"
    variant="outlined"
    helperText="Con código de área. Ej: 1132115541"
    rules={{
      required,
      validate: (value) =>
        !value || isValidArgentineMobile(value) || "Ingresá un número de celular argentino válido",
    }}
  />
);

export default PhoneInput;